import { defineMessages } from "react-intl"

export default defineMessages({
  headerPlaytestTypes: {
    id: "app.pages.profile.Playtests.headerPlaytestTypes",
  },
  receiveEmails: {
    id: "app.pages.profile.Playtests.receiveEmails",
  },
  unsubscribeText: {
    id: "app.pages.profile.Playtests.unsubscribeText",
  },
  unsubscribeConfirm: {
    id: "app.pages.profile.Playtests.unsubscribeConfirm",
  }
})
